<template>
  <div>
    <div class="lxm-login__logo">
      <img src="https://s.lingxi360.com/register/%E7%BC%96%E7%BB%84%402x.png">
    </div>
    <p class="lxm-login__logo-text">每个智慧公益背后都有灵析</p>
    <div class="lxm-login__container">
      <phone-verification :smsTime="state.time.login"
                          phoneInputName="请输入您的手机号"
                          @rqst-sms="rqstSms"></phone-verification>
      <button-primary class="lxm-login-login__primary-button"
                      :text="'登录'"
                      :loading="buttonLoading"
                      :disabled="buttonDisabled"
                      @click="clicked"></button-primary>
      <other-button :needPhone="false"></other-button>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../styles/index.styl'
  .lxm-login__container
    width: login-width
    margin: 0 auto
    padding-top: siz(22)
  .lxm-login__logo
    display: block
    padding-top: siz(59)
    img
      width: 100%
  .lxm-login__logo-text
    margin-top: siz(30)
    color: #394263
    text-align: center
    font-size: siz(16)
    font-weight: 400
    line-height: siz(26)
    height: siz(26)
  .lxm-login-login__primary-button
    margin-top: siz(60)
</style>

<script>
  import PhoneVerification from './common/PhoneVerification.vue'
  import ButtonPrimary from './common/ButtonPrimary.vue'
  import OtherButton from './common/OtherButton.vue'
  import * as aTypes from '../../store/action-types'

  export default {
    components: {
      PhoneVerification,
      ButtonPrimary,
      OtherButton
    },
    mounted () {
      this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '到达登录页' })
    },
    computed: {
      state () {
        return this.$store.state.login
      },
      buttonLoading () {
        return this.$store.state.loading[aTypes.LOGIN_WITH_PHONE]
      },
      buttonDisabled () {
        return !this.$store.state.login.verifiedPhone
      }
    },
    methods: {
      clicked () {
        this.$store.dispatch(aTypes.LOGIN_WITH_PHONE, {
          phoneNumber: this.state.verifiedPhone,
          smsCaptcha: this.state.smsVerifCode
        })
      },
      rqstSms ({ phone, code, smsType }) {
        this.$store.dispatch(aTypes.LOGIN_RQST_SMS_VALIDATION, {
          key: 'login',
          phone,
          code,
          smsType
        })
      },
      regClicked () {
        this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '登录页点注册' })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?d69d3af6